import {Component, HostListener, OnInit, ViewChild} from '@angular/core';
import {Event} from "../models/event";
import {EventService} from "../services/event.service";
import {MatDrawer} from "@angular/material/sidenav";

@Component({
    selector: 'app-events-overview',
    templateUrl: './events-overview.component.html',
    styleUrls: ['./events-overview.component.css'],
    standalone: false
})
export class EventsOverviewComponent implements OnInit {
  @ViewChild('drawer') drawer!: MatDrawer;
  searchTerm = "";

  eventTypeArray: string[] = [];
  disabilityArray: string[] = [];

  loadingEvents: Boolean = true;
  events!: Event[];

  screen_width!: number;
  hide_small!: boolean;

  constructor(
    private eventService: EventService,
  ) {}

  ngOnInit(): void {
    this.eventService.init(100);
    this.onResize();

    this.events = this.eventService.getEvents();

    this.eventService.countEvents().then(() =>{
      this.loadingEvents = false;
    });
  }

  onInputValuesChange(emitValues: { inputValue: string, eventTypeArray: string[], disabilityArray: string[] }) {
    this.searchTerm = emitValues.inputValue;
    this.eventTypeArray = emitValues.eventTypeArray;
    this.disabilityArray = emitValues.disabilityArray;
  }

  closeDrawer() {
    this.drawer.close();
  }

  /**
   * Combines the category filter and disability filter for readability
   */
  getFilteredEvents(): Event[] {
    const filteredByName = this.nameFilter(this.events);
    const filteredByCategory = this.categoryFilter(filteredByName);

    return this.disabilityFilter(filteredByCategory);
  }

  /**
   * Filters the events based on the searchterm used in the filter
   *
   * @param events
   */
  nameFilter(events: Event[]) {
    if (this.searchTerm != undefined) {
      return events.filter(event => event.name.toLowerCase().indexOf(this.searchTerm.toLowerCase()) !== -1);
    } else {
      return events;
    }
  }

  /**
   * Filters the events based on the category checkboxes
   *
   * @param events
   */
  categoryFilter(events: Event[]) {
    if (this.eventTypeArray.length > 0) {
      return events.filter(event => this.eventTypeArray.includes(event.category.toLowerCase()));
    } else {
      return events;
    }
  }

  /**
   * Filters the events based on the disability checkboxes
   *
   * @param events
   */
  disabilityFilter(events: Event[]) {
    if (this.disabilityArray.length > 0) {
      return events.filter(event =>
        this.disabilityArray.some(disability => event.accessibility[disability])
      );
    } else {
      return events;
    }
  }

  /**
   * Checks if the window size corresponds to one of the size limits
   *
   * @param event
   */
  @HostListener('window:resize', ['$event'])
  onResize(event?: any) {
    this.screen_width = window.innerWidth;
    this.hide_small = this.screen_width <= 1000;
  }
}
